import * as types from '../constants/action-types';
import { filter } from 'lodash';

const initialState = {
  error: '',
  isFetching: false,
  hasFetched: false,
  billingAddress: {
    isPosting: false,
    isFetching: false,
    postError: null,
    fetchError: null,
    hasFetched: false
  }
};

export default function fee_profile (state = initialState, action) {
  const { type, data, postError, fetchError } = action;

  switch (type) {
  case types.BILLING_CREATE_REQUEST:
    return { ...state, billingAddress: { isPosting: true } };

  case types.BILLING_CREATE_SUCCESS:
    return { ...state, billingAddress: { data: data, isPosting: false } };

  case types.BILLING_CREATE_FAILURE:
    return { ...state, billingAddress: { postError, isPosting: false } };

  case types.BILLING_FETCH_REQUEST:
    return { ...state, billingAddress: { isFetching: true } };

  case types.BILLING_FETCH_SUCCESS:
    return { ...state, billingAddress: { data: data, isFetching: false, hasFetched: true } };

  case types.BILLING_FETCH_FAILURE:
    return { ...state, billingAddress: { fetchError, isFetching: false, hasFetched: true } };

  case types.FEE_PROFILES_FETCH_REQUEST:
    return { ...state,
      isFetching: true
    };

  case types.FEE_PROFILES_FETCH_SUCCESS: {
    const billingAddress = filter(data, { type: 'BILLING' });
    const vatAddresses = filter(data, { type: 'VAT' });

    return { ...state,
      isFetching: false,
      hasFetched: true,
      billingAddress: { data: billingAddress },
      vatAddresses: { data: vatAddresses }
    };
  }

  case types.FEE_PROFILES_FETCH_FAILURE: {
    return { ...state,
      error: fetchError,
      isFetching: false,
      hasFetched: true
    }
  }

  // the fee profile for a particular invoice (could be an old deactivated address)
  case types.FETCH_ADDRESS_BY_ID_REQUEST: {
    return { ...state,
      invoiceFeeProfile: { isFetching: true }
    }
  }

  case types.FETCH_ADDRESS_BY_ID_SUCCESS: {
    return { ...state, invoiceFeeProfile: { data: data, isFetching: false, hasFetched: true } };
  }

  case types.FETCH_ADDRESS_BY_ID_FAILURE: {
    return { ...state, invoiceFeeProfile: { fetchError, isFetching: false, hasFetched: true } };
  }

  default:
    return state;
  }
}
